export enum PostTypeEnum {
  SERVICE = "SERVICE",
  BASIC = "BASIC",
  EVENT = "EVENT",
  CHALLENGE = "CHALLENGE",
  PROGRAM = "PROGRAM",
  REPOST = "REPOST",
}
export const postTypesList = [
  PostTypeEnum.SERVICE,
  PostTypeEnum.BASIC,
  PostTypeEnum.EVENT,
  PostTypeEnum.CHALLENGE,
  PostTypeEnum.PROGRAM,
  PostTypeEnum.REPOST,
];

export enum PostPrivacyEnum {
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
  CLOSED = "CLOSED",
}

export enum ChallengeStatusEnum {
  STARTED = "STARTED",
  ENDED = "ENDED",
  UPCOMING = "UPCOMING",
}
